import React, { useEffect, useState }  from "react";
import './ReportOfInterview.css';
import jsPDF from "jspdf";
import ExcelJS from 'exceljs';
import "jspdf-autotable";
import { saveAs } from "file-saver";
import { Button, Table } from "react-bootstrap";
const ReportsOfInterview =()=>{
      const [data, setData] = useState([]);

      useEffect(() => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/shortlist/All`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch data");
                }
                return response.json();
            })
            .then((data) => {
                setData(data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

   const downloadPdf = () => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Interview Report", 14, 15);

    const tableColumn = [
        "Job Id", "Position Name", "Profile Id", "Name", "Email", 
        "Mobile", "Interviewer", "Interview Date", "Status"
    ];
    
    const tableRows = data.map(item => ([
        item.jobId,
        item.positionName,
        item.profileId,
        item.name || '-',
        item.email,
        item.mobileNumber,
        item.interviewerName,
        item.interviewDate,
        item.status
    ]));

    doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: 20,
        theme: 'grid', // 'striped', 'plain', or 'grid'
        headStyles: {
            fillColor: [22, 160, 133], // Teal
            textColor: [255, 255, 255], // White
            fontStyle: 'bold',
            halign: 'center'
        },
        styles: {
            fontSize: 9,
            cellPadding: 3,
            valign: 'middle'
        },
       
        margin: { top: 20, bottom: 10 },
        didDrawPage: (data) => {
            // Footer (optional)
            const pageCount = doc.internal.getNumberOfPages();
            doc.setFontSize(8);
            doc.text(`Page ${data.pageNumber} of ${pageCount}`, data.settings.margin.left, doc.internal.pageSize.height - 10);
        }
    });

    doc.save("Interview_Report.pdf");
};


    const downloadExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Interview Report");

    // Define header row with styling
    worksheet.columns = [
        { header: "Job Id", key: "jobId", width: 10 },
        { header: "Position Name", key: "positionName", width: 20 },
        { header: "Profile Id", key: "profileId", width: 15 },
        { header: "Name", key: "name", width: 20 },
        { header: "Email", key: "email", width: 25 },
        { header: "Mobile", key: "mobileNumber", width: 15 },
        { header: "Interviewer", key: "interviewerName", width: 20 },
        { header: "Interview Date", key: "interviewDate", width: 20 },
        { header: "Status", key: "status", width: 15 },
    ];

    // Add data rows
    data.forEach(item => {
        worksheet.addRow({
            jobId: item.jobId,
            positionName: item.positionName,
            profileId: item.profileId,
            name: item.name || '-',
            email: item.email,
            mobileNumber: item.mobileNumber,
            interviewerName: item.interviewerName,
            interviewDate: item.interviewDate,
            status: item.status
        });
    });

    // Style header row
    worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true };
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFCCE5FF' }, // Light blue
        };
        cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        };
        cell.alignment = { horizontal: 'center' };
    });

    // Write to buffer and trigger download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, "Interview_Report.xlsx");
};


    return(
        <React.Fragment>
            <div className="interview-report-main">
                <div className="interview-report">
                    <h4>Interview Report</h4>
                    <div className="interview-report-btn">
                        <Button onClick={downloadPdf}>Download Pdf</Button>
                        <Button onClick={downloadExcel}>Download Excel</Button>
                    </div>
                </div>
                <div className="interview-report-table">
                    <Table>
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Job Id</th>
                                <th>Position Name</th>
                                <th>Profile Id</th>
                                <th>Name</th>
                                <th>Candidate Email</th>
                                <th> Candidate Mobile Number</th>
                                <th>Interviewer Name</th>
                                 <th>Scheduled Date</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                         <tbody>
                        {data.length > 0 ? (
                            data.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td> 
                                    <td>{item.jobId}</td>
                                    <td>{item.positionName}</td>
                                    <td>{item.profileId}</td>
                                    <td>{item.name || '-'}</td>
                                    <td>{item.email}</td>
                                    <td>{item.mobileNumber}</td>
                                    <td>{item.interviewerName}</td>
                                    <td>{item.interviewDate}</td>
                                    <td>{item.status}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9">Loading or No Data Available</td>
                            </tr>
                        )}
                    </tbody>
                    </Table>
                </div>
                </div>
        </React.Fragment>
    )
}
export default ReportsOfInterview;